module.exports = __webpack_public_path__ + "static/media/default_avatar.c4f1450e.svg";